<template>
  <div
    :class="[
      `page`,
      appPage.classes,
      {
        'page--is-loaded': appState.loaded,
      },
    ]"
    :id="`app`"

    :data-env="appEnv"
  >
    <ui-header/>
    <transition
      name="loader"
      mode="out-in"

      @appear="onLoad()"
      @enter="onLoad()"
      @leave="onLeave()"
    >
      <router-view :key="$route.meta.key || $route.fullPath"/>
    </transition>

    <module-modal
      id="login"
      :auto="true"
      :no-close="true"
      auth="login"
    />
  </div>
</template>

<style lang="scss">
    ._debug { margin: 20px 0; font-size: 14px; min-height: 0; }
    ._debug--fixed { border: 0; position: fixed; top: 0; right: 0; padding: 5px 10px; background: rgba(0,0,0,0.5); color: white; z-index: 9999; white-space: pre-wrap; white-space: normal; margin: 0; width: 100%; pointer-events: none; white-space: pre2; }
    @import '../assets/main.scss';
</style>

<script>
// Config
import config from 'config';

// Vuex
import { mapGetters, mapActions } from 'vuex';

// Services
import { createMeta } from 'services/meta';
import { injectGtag } from 'services/gtag';
import { injectLiveChat } from 'services/livechat';

// Modules
import ModuleModal from 'modules/Modal';

// UI
import UiAuth from 'ui/Auth';
import UiHeader from 'ui/Header';

// Export
export default {
  name: `app`,

  // Meta info
  metaInfo() {
    return {
      titleTemplate(titleChunk) {
        return `${config.env !== `prod` ? `[${config.env}] ` : ``}${config.name}${titleChunk ? `${config.meta.separator}${titleChunk}` : ``}`;
      },
      htmlAttrs: {
        prefix: `og: http://ogp.me/ns#`,
      },
      meta: createMeta({
        type: `website`,
        url: `${config.rootUrl}${this.$route.fullPath}`,
        title: this.metaTitle,
        company: config.name,
        image: config.openGraph,
      }),
      changed(metaInfo/*, added, removed*/) {
        if (metaInfo.title !== this.metaTitle && this.updateMetaTitle) {
          this.updateMetaTitle(metaInfo.title);
        }

        if (this.$route.name && metaInfo.titleChunk) {
          document.dispatchEvent(new Event(`custom-post-render-event`));
        }

        if (this.updateMeta) {
          this.updateMeta(metaInfo);
        }
      },
    };
  },

  // Components
  components: {
    ModuleModal,
    UiAuth,
    UiHeader,
  },

  // Data
  computed: {
    ...mapGetters(`meta`, [
      `metaTitle`,
    ]),
    ...mapGetters(`app`, [
      `appEnv`,
      `appState`,
      `appPage`,
    ]),
    ...mapGetters(`modals`, [
      `modalActive`,
    ]),
  },
  watch: {
    modalActive(active) {
      const classList = document.body.classList;
      const className = `body--modal-open`;

      active ? classList.add(className) : classList.remove(className);
    },
  },

  // Methods
  methods: {
    ...mapActions(`app`, [
      `openLoader`,
      `updatePage`,
      `closeLoader`,
      `updateViewport`,
      `setTouch`,
    ]),
    ...mapActions(`meta`, [
      `updateMeta`,
      `updateMetaTitle`,
    ]),
    ...mapActions(`modals`, [
      `closeModal`,
    ]),
    ...mapActions(`review`, [
      `getNomenclature`,
    ]),
    onLeave() {
      this.openLoader();
      this.closeModal();
    },
    onLoad() {
      this.updatePage();

      if (this.appState.init) {
        this.closeLoader();
      }
    },
  },

  // Lifecycle
  created() {
    injectGtag();
    this.updateViewport();
    this.setTouch();
    this.getNomenclature();

    window.addEventListener(`resize`, () => this.updateViewport(), true);
  },
  mounted() {
    injectLiveChat();
  },
  destroyed() {
    window.removeEventListener(`resize`, () => this.updateViewport(), true);
  },
};
</script>



// WEBPACK FOOTER //
// App.vue?2c30fbec